import { Controller } from '@hotwired/stimulus'
import { useHover } from 'stimulus-use'

export default class extends Controller {
    static targets = ['trigger', 'target']

    connect() {
        if (this.hasTriggerTarget) {
            this.triggerTargets.forEach((trigger) => {
                useHover(this, {element: trigger})
            })
        }
    }

    mouseEnter(e) {
        this._toggleClass(e)
    }
    
    mouseLeave(e) {
        this._toggleClass(e)
    }
    
    _toggleClass(e) {
        const targets = this.element.querySelectorAll(`[data-target='${e.currentTarget.getAttribute('data-target-identifier')}']`)
        if (targets) {
            targets.forEach((target) => {
                target.classList.toggle(e.currentTarget.getAttribute('data-toggle-class'))
            })
        }
    }
}
